<script setup lang="ts">
import {Survey} from "@/core/interfaces/survey/Survey";
import {Laboratory} from "@/core/interfaces/laboratory/Laboratory";
import BaseLogo from "@/core/components/logo/BaseLogo.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {inject} from "vue";
import {useRouter} from "vue-router";

const router = useRouter();
const emits = defineEmits<{ (e: 'surveyCompleted'): void; }>();
const props = defineProps<{
    surveys: Survey[];
    laboratories: Laboratory[];
    consumerKey: string;
}>();


const openSurveyModal = inject<(
    surveyId: number,
    consumerKey: string,
    pathwayStepId: number | null,
    supportProgramId: number | null,
    type?: string,
    options?: Record<string, unknown>
) => void>('openSurveyModal');

/**
 * Start the survey by opening the survey modal.
 */
const startSurvey = (survey: Survey) => {
    if (openSurveyModal && !survey.flowchart?.id) {
        openSurveyModal(
            survey.id,
            props.consumerKey,
            null,
            null,
            'survey',
            {
                showVerdict: true,
                onClose: handleSurveyCompleted,
                consent: survey.consent
            }
        );
    }

    if (survey.flowchart?.id) {
        router.push({name: 'flowcharts.show', params: {id: survey.flowchart!.id}});
    }
};

/**
 * Handle the survey completed event.
 */
const handleSurveyCompleted = () => {
    emits('surveyCompleted');
};
</script>

<template>
  <h1 class="pt-4">
    Assistants conseil
  </h1>
  <p class="text-small">
    Trouvez facilement le produit adapté à votre patient avec les outils de recommandations de vos partenaires.
  </p>
  <div v-for="laboratory in laboratories" :key="laboratory.id">
    <div
      class="flex flex-row gap-3 items-center my-4 p-2 rounded-md"
      :style="{ backgroundColor: laboratory.branding?.primary_color ?? laboratory.color}"
    >
      <BaseLogo
        :alt="laboratory.name"
        :logo="laboratory.logo"
        img-class="object-contain hover:border-2 hover:border-transparent"
        class="max-h-20"
      />
      <div class="flex flex-row gap-3 flex-wrap">
        <div
          v-for="survey in surveys.filter(s => s?.flowchart?.laboratory_id === laboratory.id)"
          :key="survey.id"
        >
          <base-button
            density="comfortable"
            @click="startSurvey(survey)"
            @survey-completed="handleSurveyCompleted"
          >
            {{ survey.theme ?? survey.name }} >
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
